import { render, staticRenderFns } from "./KreativBoard.vue?vue&type=template&id=17604653&scoped=true"
import script from "./KreativBoard.vue?vue&type=script&lang=js"
export * from "./KreativBoard.vue?vue&type=script&lang=js"
import style0 from "./KreativBoard.vue?vue&type=style&index=0&id=17604653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17604653",
  null
  
)

export default component.exports